import { Box, Container, Text } from '@chakra-ui/react'
import { Helmet } from 'react-helmet'

export const About = () => {
  return (
    <Box w='100%' p={4} pb={8}>
      <Helmet>
        <title>About | Songvisor</title>
      </Helmet>
      <Container maxW='3xl'>
        <Text>
          Welcome to Songvisor, your personal AI assistant revolutionizing the way music supervisors
          discover the perfect soundtrack for every scene. Powered by the cutting-edge ChatGPT-4
          technology, Songvisor is designed exclusively for music supervisors and content creators
          bringing a seamless experience to match emotions, themes, and descriptions with the ideal
          music choices.
        </Text>

        <Text fontSize='xl' fontWeight='bold' pt={4} pb={4}>
          What is Songvisor?
        </Text>
        <Text>
          Imagine a tool that comprehends the complexities of your creative vision. Songvisor is
          your creative partner, understanding not just the mood and theme you&apos;re seeking but
          also the essence and intricate details you describe. It&apos;s an intuitive platform that
          delves into your vision, swiftly curating a selection of songs tailored precisely to your
          specifications.
        </Text>

        <Text fontSize='xl' fontWeight='bold' pt={4} pb={4}>
          How Songvisor Works
        </Text>
        <Text>
          At the heart of Songvisor lies ChatGPT-4, an advanced AI model finely tuned to comprehend
          human expressions. Simply describe the moment, the feelings, the overarching theme, or the
          subtle nuances of a scene, and Songvisor will present a curated list of songs that
          encapsulate those emotions.
        </Text>

        <Text fontSize='xl' fontWeight='bold' pt={4} pb={4}>
          Why Choose Songvisor?
        </Text>
        <ul>
          <li>
            <Text fontWeight='bold'>Precision in Curation:</Text>
            <Text>
              Say goodbye to sifting through endless libraries. Using the power of ChatGPT,
              Songvisor can deliver songs that align perfectly with your vision.
            </Text>
          </li>
          <br />
          <li>
            <Text fontWeight='bold'>Efficiency Redefined:</Text>
            <Text>
              Instantly access a range of songs without hours of search. Songvisor understands your
              needs swiftly, allowing you to focus on what matters most—your creativity.
            </Text>
          </li>
          <br />
          <li>
            <Text fontWeight='bold'>Unleash Creativity:</Text>
            <Text>
              Discover unique, fitting tracks that elevate your projects, transforming scenes into
              unforgettable experiences.
            </Text>
          </li>
        </ul>

        <Text fontSize='xl' fontWeight='bold' pt={4} pb={4}>
          Our Vision
        </Text>
        <Text>
          At Songvisor, we believe in the power of music to elevate storytelling. Our mission is to
          empower music supervisors, content creators, and storytellers by providing a tool that
          seamlessly integrates into their creative process, enhancing the emotional depth of their
          projects.
        </Text>
      </Container>
    </Box>
  )
}
